import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { parseDate } from '@/utils'
import { App } from 'vue'
// import { ID_INJECTION_KEY } from "element-plus"
// append-to-body
import { ElDialog, ElInput, ElSelect, ElForm, ElDatePicker } from 'element-plus'

ElDialog.props.appendToBody.default = true
ElDialog.props.closeOnClickModal.default = false
ElDialog.props.showClose.default = false
ElInput.props.resize.default = 'none'
ElSelect.props.filterable = {
	type: Boolean,
	default: true
}
ElForm.props.labelPosition.default = 'left'
ElForm.props.labelWidth.default = 'auto'
ElForm.props.scrollToError = {
	type: Boolean,
	default: true
}
ElForm.props.scrollIntoViewOptions.default = {
	block: 'center',
	// 值有auto、instant,smooth，缓动动画（当前是慢速的）
	behavior: 'smooth'
}
// 默认100个字符
ElInput.props.maxlength.default = 100
// 日期不可选超过限制之外的
ElDatePicker.props.disabledDate.default = (time: Date) => {
	return time.getTime() > parseDate('9999/12/31').getTime() || time.getTime() < parseDate('1900/01/01').getTime()
}
// ElInputNumber.props.max.default = 100000
// ElInput.props.showWordLimit.default = true
export default function initElement(app: App) {
	// .provide(ID_INJECTION_KEY, {
	// 	prefix: Math.floor(Math.random() * 10000),
	// 	current: 0
	// })
	app.use(ElementPlus)
	for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
		app.component(key, component)
	}
	//app.config.globalProperties.$message = ElMessage
}
